module.exports = __webpack_public_path__ + "static/img/materialsInfo1.f6558c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo1.png
// module id = nM6D
// module chunks = 2